import React from 'react';
import './Shapes.css';

const Shapes = () => {
    return (
        <div className="shapes__wrapper">
            <div className="welcome">
                <h1>Shapes</h1>
            </div>
            <div className="square">
                <ul>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                </ul>
            </div>
            <div className="circle">
                <ul>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                </ul>
            </div>
        </div>
    )
}

export default Shapes
